import { DataGrid, SelectBox } from "devextreme-react";
import React, { useCallback, useMemo } from "react";
import { getPropsDataGrid, getPropsDateEdit, getPropsDataGridEditing, getPropsDataGridPopup } from "../../../utils/default-props";
import { Column, Editing, FormItem, Lookup, Popup } from "devextreme-react/data-grid";
import { useDataSource } from "../../../contexts/dataSource";
import { useAuth } from "../../../contexts/auth";
import { getDataGridCustomToolbar } from "../../../components/default-components/data-grid-custom-toolbar";
import { useLookupGroup } from "../../../contexts/lookup-group-context";
import { useState } from "react";
import { useEffect } from "react";
import { lookupGroups } from "../../../utils/lookup-groups.ts";

function Policy(props) {

    const { employeeId } = props
    const { dataSourceHR } = useDataSource()
    const { user, activeLanguage } = useAuth()
    const { getLookupData } = useLookupGroup()

    const [policyTypeList, setPolicyTypeList] = useState()

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: `/api/EmployeePolicy/Employee/${employeeId}`,
        insertUrl: "/api/EmployeePolicy/FormData"
    }), [user, employeeId])

    const dbPolicyCompnay = useMemo(() => dataSourceHR({
        loadUrl: "/api/PolicyCompanyInfo"
    }), [user])

    const policyTypeOption = useMemo(() => (
        {
            items: policyTypeList,
            valueExpr: "id",
            displayExpr: "text"
        }
    ), [policyTypeList])

    const handleInitNewRow = useCallback((e) => {
        e.data.employeeId = employeeId
        e.data.active = true
    }, [employeeId])

    useEffect(() => {
        getLookupData(lookupGroups.policyType).then(response => {
            setPolicyTypeList(response)
            console.log(response)
        })
    }, [activeLanguage])

    useEffect(() => {
        console.log("policyTypeList", policyTypeList)
    }, [policyTypeList])
    return (
        <React.Fragment>
            <DataGrid
                {...getPropsDataGrid}
                dataSource={dataSource}
                onInitNewRow={handleInitNewRow}
            >
                <Editing {...getPropsDataGridEditing}>
                    <Popup {...getPropsDataGridPopup} title="Sigorta Bilgisi" />
                </Editing>

                {getDataGridCustomToolbar("Sigorta Bilgileri")}
                <Column dataField="policyCompanyInfoId" caption="Sigorta Firması" >
                    <FormItem colSpan={2} />
                    <Lookup dataSource={dbPolicyCompnay} valueExpr="id" displayExpr="name" />
                </Column>
                <Column dataField="policyTypeId"
                    caption="Sigorta Türü"
                    editorType="dxSelectBox"
                    editorOptions={policyTypeOption}
                >
                    <Lookup dataSource={policyTypeList} displayExpr="text" valueExpr="id" />

                </Column>
                <Column dataField="policyNumber"
                    caption="Poliçe No"
                />
                <Column dataField="startDate"
                    caption="Başlangıç Tarihi"
                    {...getPropsDateEdit}
                />
                <Column dataField="endDate" caption="Bitiş Tarihi"
                    {...getPropsDateEdit}
                />
                <Column dataField="amount" caption="Tutar" />
            </DataGrid>
        </React.Fragment>
    )
}
export default Policy